// // socket地址
// export const SOCKET_URL = process.env.SOCKET_URL

// // 接口地址
// export const API_BASE_URL = process.env.VUE_APP_API_BASE_URL

// // 上传 post
// export const UPLOAD = API_BASE_URL + '/file/upload' 

// 项目名称
export const PROJECT_NAME = process.env.VUE_APP_NAME

// 页签同路由不同参数可重复打开的路由
export const REPEATABLE_TABS = ['/system/user-info']

// 不需要登录的路由
export const WHITE_LIST = []

// token 传递的 header 名称
export const TOKEN_HEADER_NAME = 'baoling-token'

// token 存储的名称
export const TOKEN_STORE_NAME = 'access_token'

// 个人信息 存储的名称
export const USERINFO_STORE_NAME = '__user_info'

// 能力等级下拉列表
export const LEVEL_OPTION = [
  { label: '老年人能力评估（2022年）', value: 'elderlyAbilities' },
  { label: '长期护理失能等级评估', value: 'longTermCare' },
  { label: 'CGA标准版', value: 'standard' }
]